import { OrbitalMark } from "@/components/aph/OrbitalLock";

export const Loader = () => (
  <div className="h-[100dvh] w-full flex items-center justify-center bg-void starfield" data-testid="app-loader">
    <OrbitalMark className="w-14 h-14" spinning />
  </div>
);

export const Avatar = ({ name, group, size = "w-10 h-10" }) => (
  <div className={`${size} flex-shrink-0 rounded-full flex items-center justify-center font-branding font-bold text-sm border ${group ? "border-ash/25 text-ash bg-nebula" : "border-stellar/60 text-stellar bg-gradient-to-tr from-stellar/20 to-transparent"}`}>
    {(name || "?").trim().slice(0, group ? 2 : 1).toUpperCase()}
  </div>
);
